/* eslint-disable import/extensions */
// 考虑会魔改laya底层，所以这里引入固定js文件，没事不会升级
// import外部类库的顺序不可更改
import '../libs/layabox/laya.core.js';
import '../libs/layabox/laya.html.js';
import '../libs/layabox/laya.ani.js';
//# sourceMappingURL=index.js.map